export default [
  {
    id: '486802036776501504',
    name: 'American Electric Power',
    description:
      'If you have more than one account with AEP, please add each account separately. Please note that paper bills will be terminated immediately.',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.aep.com',
    logoKey: 'https://logos.quicken.com/7c2783b2159a94c982bab12bee0d81c0c08433764ad5dd1b1584f809c7ab93cf.jpg',
    classification: 'Utilities',
    activation: 'REAL_TIME',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486838678484680960',
    name: 'Arizona Public Service',
    description:
      'Thank you for enrolling in ebilling with APS (Arizona Public Service). Once activated, you can expect to see your first electronic bill for your next billing statement and will no longer receive a paper bill via the US Mail.',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.aps.com',
    logoKey: 'https://logos.quicken.com/194572854c4506097dffc09928202863db3ae4f0b55707ede2681c4e53efc60a.jpg',
    classification: 'Utilities',
    activation: 'BATCH',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486802035769868544',
    name: 'Allstate Insurance Company',
    description:
      'By enrolling you authorize Allstate Insurance Co. & Affiliates to send your bills electronically and stop paper bills. Please pay all paper bills until your  first e-Bill arrives. Life, Motor Club, Parts/Labor, and Mortgage Escrow bills are not eligible.',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.allstate.com',
    logoKey: 'https://logos.quicken.com/0acbaa73f4e9c1f31f645afde96f32c028bb87048974fcf35c65a929ae4bf508.jpg',
    classification: 'Insurance',
    activation: 'BATCH',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486802034729681152',
    name: 'Atmos Energy',
    description:
      'If you are currently enrolled in the Atmos Energy e-bill program, you are not eligible for e-Bill enrollment.',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.atmosenergy.com',
    logoKey: 'https://logos.quicken.com/123f70a3cfcb32dea054ef17d477d960e61a18b25b64d5b271878c2f26370aa3.jpg',
    classification: 'Utilities',
    activation: 'REAL_TIME',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486839584018137344',
    name: 'Commonwealth Edison',
    description:
      'Please note: Eligibility is limited to residential accounts and certain exclusions apply.  You will continue to receive your ComEd paper bill for a one month trial period.  For more information, please visit the ComEd web site at http://www.comed.com',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.comed.com',
    logoKey: 'https://logos.quicken.com/dc449b31b7876ca8a75d6a4716638570df466358e818d166183fc4cccf376c58.jpg',
    classification: 'Utilities',
    activation: 'REAL_TIME',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486838677696151808',
    name: 'Cox Communications',
    description:
      'Thank you for your interest in receiving a Cox Communications E-Bill.  If you have more than one Cox account, please enroll each one separately.  Please review Cox paper suppression Terms and Conditions by clicking on the link.',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.cox.com',
    logoKey: 'https://logos.quicken.com/94890d927499ab5c9469a935d38cd813b8aeb17b4778fe76fbc700c90cdeb6e3.jpg',
    classification: 'Telecom',
    activation: 'BATCH',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486802035753091328',
    name: 'Duke Energy Carolinas',
    description:
      'Thank you for enrolling to receive your Duke Energy bill online. Once enrolled, you will no longer receive a paper bill.',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.duke-energy.com',
    logoKey: 'https://logos.quicken.com/a660a0462019a23a316d4cdce7ca6d998da74051d4f3ede7508bd2f6f8e95c5f.jpg',
    classification: 'Utilities',
    activation: 'BATCH',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486802036273185024',
    name: 'Duke Energy Florida',
    description:
      'Thank you for enrolling to receive your Duke Energy bill online. Once enrolled, you will no longer receive a paper bill.',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.duke-energy.com',
    logoKey: 'https://logos.quicken.com/a660a0462019a23a316d4cdce7ca6d998da74051d4f3ede7508bd2f6f8e95c5f.jpg',
    classification: 'Utilities',
    activation: 'BATCH',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486802034545131776',
    name: 'Duke Energy Indiana',
    description:
      'Thank you for enrolling to receive your Duke Energy bill online. Once enrolled, you will no longer receive a paper bill.',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.duke-energy.com',
    logoKey: 'https://logos.quicken.com/a660a0462019a23a316d4cdce7ca6d998da74051d4f3ede7508bd2f6f8e95c5f.jpg',
    classification: 'Utilities',
    activation: 'BATCH',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486802035702759680',
    name: 'Duke Energy Kentucky',
    description:
      'Thank you for enrolling to receive your Duke Energy bill online. Once enrolled, you will no longer receive a paper bill.',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.duke-energy.com',
    logoKey: 'https://logos.quicken.com/a660a0462019a23a316d4cdce7ca6d998da74051d4f3ede7508bd2f6f8e95c5f.jpg',
    classification: 'Utilities',
    activation: 'BATCH',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486802035652428032',
    name: 'Duke Energy Ohio',
    description:
      'Thank you for enrolling to receive your Duke Energy bill online. Once enrolled, you will no longer receive a paper bill.',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.duke-energy.com',
    logoKey: 'https://logos.quicken.com/a660a0462019a23a316d4cdce7ca6d998da74051d4f3ede7508bd2f6f8e95c5f.jpg',
    classification: 'Utilities',
    activation: 'BATCH',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486802034176033024',
    name: 'Duke Energy Progress',
    description:
      'Thank you for enrolling to receive your Duke Energy bill online. Once enrolled, you will no longer receive a paper bill.',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.duke-energy.com',
    logoKey: 'https://logos.quicken.com/a660a0462019a23a316d4cdce7ca6d998da74051d4f3ede7508bd2f6f8e95c5f.jpg',
    classification: 'Utilities',
    activation: 'BATCH',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486838678904111360',
    name: 'Florida Power & Light',
    description: 'Once your bill is available electronically, FPL will no longer mail paper bills.',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.fpl.com',
    logoKey: 'https://logos.quicken.com/993ab75cb84360de90989284d632df55d3f080119d5428ae7bb090466112b9e6.jpg',
    classification: 'Utilities',
    activation: 'BATCH',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486802035501433088',
    name: 'Nicor Gas',
    description:
      'After your next paper bill, all future bills can be found through your electronic service provider.  You can stay informed about your Nicor Gas service at www.nicor.com or call us toll-free at 1-888-NICOR4U (642-6748).',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.nicorgas.com',
    logoKey: 'https://logos.quicken.com/36ff1b5759016b8a19f66268e3ad080e75709bbe11e7275ed77a18bdb2e32637.jpg',
    classification: 'Utilities',
    activation: 'BATCH',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486802036155744512',
    name: 'NV Energy North',
    description:
      'NV Energy Paperless Billing. With this convenient service, paying and viewing your power bill is just a click away. No more stamps.  No more envelopes. No more checks.',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.nvenergy.com',
    logoKey: 'https://logos.quicken.com/27f89b274b142ac3759c7af4b7af87d3af40be1f33dff52a08c9bc7f234cbdee.jpg',
    classification: 'Utilities',
    activation: 'BATCH',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486802034444468480',
    name: 'NV Energy South',
    description:
      'NV Energy Paperless Billing. With this convenient service, paying and viewing your power bill is just a click away. No more stamps.  No more envelopes. No more checks.',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.nvenergy.com',
    logoKey: 'https://logos.quicken.com/27f89b274b142ac3759c7af4b7af87d3af40be1f33dff52a08c9bc7f234cbdee.jpg',
    classification: 'Utilities',
    activation: 'BATCH',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486802036189298944',
    name: 'National Grid',
    description:
      'National Grid allows you to view and pay your bill online. You will no longer receive a printed paper bill. For assistance, contact www.NationalGridUS.com/ContactUs.',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.nationalgrid.com',
    logoKey: 'https://logos.quicken.com/6e4f129b69dad628c9c6e7c7c5d50372434285c36bb1db8c568498d5ff32bd2c.jpg',
    classification: 'Utilities',
    activation: 'REAL_TIME',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486802035165888769',
    name: 'PECO Energy',
    description:
      'Please note: It may take one full billing cycle to receive your first electronic bill.  You will continue to receive your PECO Energy paper bill for a one month trial period.',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.peco.com',
    logoKey: 'https://logos.quicken.com/fd37a8e605163acc0086a23a0b5265d625244e55defcb2d4d24434431466fa65.jpg',
    classification: 'Utilities',
    activation: 'REAL_TIME',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486802036759724288',
    name: 'Puget Sound Energy',
    description:
      'You will no longer receive a printed bill.  For questions regarding PSE services, bills, rates and responsibilities, please feel free to contact our Customer Care Agents at 1-888-225-5773 or  e-mail us at customercare@pse.com',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.pse.com',
    logoKey: 'https://logos.quicken.com/d1a3537dafd63b8c01545a98011d33836e5cf25a87214e50c2817ed179f8ce72.jpg',
    classification: 'Utilities',
    activation: 'REAL_TIME',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486802036692615424',
    name: 'Pacific Gas & Electric',
    description:
      "Thank you for choosing to pay your PG&E bill online. When you sign up for e-Bills, you'll receive one more paper bill before PG&E stops sending your monthly paper bill. You can print a copy of your online statement.",
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.pge.com',
    logoKey: 'https://logos.quicken.com/cb493328c39630c98b44f8d76cb7686c6089e545649a9d1805887389fc805317.jpg',
    classification: 'Utilities',
    activation: 'REAL_TIME',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486802036021526784',
    name: 'Progressive Insurance',
    description:
      'Thank you for adding Progressive Insurance.  Please note; you will continue to receive a paper bill in the mail,  If you were an EFT customer, you are no longer on that plan and need to pay at your payment site. Commercial Auto is not eligible for e-bill.',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.progressive.com',
    logoKey: 'https://logos.quicken.com/4ae4e1eac5f9114a824e68f6114ddd90380a2cbbd3e8de3d8bbc60932ca6cd49.jpg',
    classification: 'Insurance',
    activation: 'BATCH',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486802034561908992',
    name: 'Southern California Gas Company',
    description:
      'Your paper bills will be discontinued once your e-Bill request is accepted.  If you have multiple SoCalGas accounts, add each one separately.  E-Bill Terms & Conditions are located at http://www.socalgas.com/terms-and-conditions/my-account',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.socalgas.com',
    logoKey: 'https://logos.quicken.com/725c1b81ce6f68885f8670592d363bedcab733e7239b2553f2bab60206d69472.jpg',
    classification: 'Utilities',
    activation: 'BATCH',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486838677998141696',
    name: 'Verizon Wireless',
    description:
      'By signing up for paperless billing, you authorize Verizon Wireless to send you notices regarding your Verizon Wireless service by email.  Your summary electronic bill will be available within the next 2 cycles and your paper bill will be discontinued.',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.verizon.com',
    logoKey: 'https://logos.quicken.com/9f0f1d59232eb5cc8912891f20ac79c3382cb6a6ddaa3219fa6ea580246c1516.jpg',
    classification: 'Telecom',
    activation: 'REAL_TIME',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486840011770036480',
    name: 'Waste Connections',
    description:
      'Customers that enroll in electronic bill presentment will stop receiving paper bills upon successful enrollment. To successfully enroll, your account number must include four digits with a dash and then the remaining digits (ex.1234-56789).',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://www.wasteconnections.com',
    logoKey: 'https://logos.quicken.com/6b34b17ccb9f2f81827b556bdcbd72d2df92df7a0ff9b6097af9c3dbd4e2c9c5.jpg',
    classification: 'Waste Management',
    activation: 'BATCH',
    purpose: 'PRESENTMENT',
  },
  {
    id: '486802036910719232',
    name: 'Xcel Energy',
    description:
      'Thank you for signing up for Online View & Pay.  To smooth your transition to this service, we will send you one more paper bill.  Then you will see future statements online only and can print them for your records.',
    mode: 'PARTNER',
    network: 'FISERV',
    status: 'ACTIVE',
    url: 'https://my.xcelenergy.com',
    logoKey: 'https://logos.quicken.com/76af8eeea4c969f0247a4e292dc1ac61ecfdaa92ab855ebbe5a8baeb91cd4e38.jpg',
    classification: 'Utilities',
    activation: 'REAL_TIME',
    purpose: 'PRESENTMENT',
  },
];
